"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "mb-6 text-xl font-semibold" };
var _hoisted_2 = { class: "mb-8 flex gap-2 rounded-lg bg-gray-20 p-4" };
var _hoisted_3 = { class: "text-sm leading-5 text-black/80" };
var _hoisted_4 = { class: "mb-2 text-lg font-semibold" };
var _hoisted_5 = { class: "mb-8 text-sm text-gray-70" };
var _hoisted_6 = { class: "mb-4 mt-8 text-lg font-semibold" };
var _hoisted_7 = { class: "mb-6 grid grid-cols-[min-content,1fr] items-center gap-x-2" };
var _hoisted_8 = { class: "mb-4 flex items-center justify-between gap-3 text-sm font-semibold" };
var _hoisted_9 = { for: "withdrawal-article-numbers" };
var _hoisted_10 = { class: "text-xs font-normal text-gray-70" };
var _hoisted_11 = { class: "mb-8 flex items-start gap-2" };
var _hoisted_12 = { class: "text-sm leading-5 text-gray-80" };
var _hoisted_13 = { class: "mb-6 text-lg font-semibold leading-6" };
var _hoisted_14 = {
    key: 0,
    class: "text-gray-70"
};
var vue_3 = require("vue");
var vue_i18n_1 = require("vue-i18n");
var googleCaptcha_1 = require("@ocm/services/googleCaptcha");
var SvgIcon_vue_1 = require("@SharedVueComponents/SvgIcon/SvgIcon.vue");
var InfoModal_vue_1 = require("@SharedVueComponents/Modal/InfoModal.vue");
var LoadingSpinner_vue_1 = require("@/components/LoadingSpinner.vue");
var TransitionSection_vue_1 = require("@/components/TransitionSection.vue");
var use_autofill_1 = require("@/composables/use-autofill");
var use_mail_1 = require("@/composables/use-mail");
var use_trackingErrors_1 = require("@/composables/use-trackingErrors");
var use_polly_1 = require("@/composables/use-polly");
var captcha_config_1 = require("@/queries/captcha.config");
var use_messageData_1 = require("@/composables/use-messageData");
var articleNumbersMaxLength = 550;
exports.default = (0, vue_1.defineComponent)({
    __name: 'WithdrawalPage',
    setup: function (__props) {
        var _this = this;
        var t = (0, vue_i18n_1.useI18n)({}).t;
        var captchaElement = (0, vue_3.ref)();
        var captchaToken = (0, vue_3.ref)();
        var captchaWidgetID = (0, vue_3.ref)(0);
        var loading = (0, vue_3.ref)(false);
        var articleNumbersCharacterCount = (0, vue_3.computed)(function () { var _a, _b; return (_b = (_a = use_messageData_1.description.value) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0; });
        var formErrors = (0, vue_3.computed)(function () { return (use_mail_1.mailErrorText.value ? [t(use_mail_1.mailErrorText.value)] : []); });
        var hideLoadingSpinner = function () {
            loading.value = false;
        };
        var showLoadingSpinner = function () {
            loading.value = true;
        };
        var submit = function () {
            var _a;
            if ((_a = captcha_config_1.captchaData.value) === null || _a === void 0 ? void 0 : _a.captchaActive) {
                executeCaptcha();
            }
            else {
                submitMail();
            }
        };
        var submitMail = function () { return __awaiter(_this, void 0, Promise, function () {
            var token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        token = captchaToken.value || "no-token";
                        showLoadingSpinner();
                        return [4 /*yield*/, (0, use_mail_1.sendWithdrawalMail)(token)];
                    case 1:
                        _a.sent();
                        hideLoadingSpinner();
                        return [2 /*return*/];
                }
            });
        }); };
        (0, vue_3.onBeforeMount)(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        use_polly_1.currentCollection.value = undefined;
                        (0, use_messageData_1.resetInputData)();
                        return [4 /*yield*/, (0, captcha_config_1.getCaptchaData)()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, (0, use_autofill_1.getAndAutofillContactData)(t, true)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        (0, vue_3.watch)(function () { return captchaElement.value; }, function () {
            renderCaptcha();
        });
        var renderCaptcha = function () { return __awaiter(_this, void 0, void 0, function () {
            var captchaConfig, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!captchaElement.value || !captcha_config_1.captchaData.value)
                            return [2 /*return*/];
                        captchaConfig = {
                            sitekey: captcha_config_1.captchaData.value.publicKey,
                            size: "invisible",
                            callback: verifyCaptcha,
                            "error-callback": errorCaptcha,
                            "expired-callback": expiredCaptcha,
                        };
                        _a = captchaWidgetID;
                        return [4 /*yield*/, (0, googleCaptcha_1.captchaRender)(captchaElement.value, captchaConfig)];
                    case 1:
                        _a.value = _b.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        var executeCaptcha = function () {
            (0, googleCaptcha_1.captchaExecute)(captchaWidgetID.value);
        };
        var verifyCaptcha = function (token) {
            captchaToken.value = token;
            submitMail();
        };
        var expiredCaptcha = function () {
            use_mail_1.mailErrorText.value = "personalDataPage.captchaError";
            console.log("expired");
        };
        var errorCaptcha = function () {
            use_mail_1.mailErrorText.value = "personalDataPage.captchaError";
            console.log("error captcha");
        };
        return function (_ctx, _cache) {
            var _a;
            var _component_FormKit = (0, vue_2.resolveComponent)("FormKit");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", null, [
                (0, vue_2.createVNode)(TransitionSection_vue_1.default, null, {
                    default: (0, vue_2.withCtx)(function () { return [
                        (loading.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(LoadingSpinner_vue_1.default, { key: 0 }))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]; }),
                    _: 1
                }),
                (0, vue_2.createElementVNode)("h2", _hoisted_1, (0, vue_2.toDisplayString)(_ctx.$t("withdrawalPage.headline")), 1),
                (0, vue_2.createElementVNode)("section", _hoisted_2, [
                    (0, vue_2.createVNode)(SvgIcon_vue_1.default, {
                        "icon-name": "info",
                        class: "mt-0.5 h-5 w-5 shrink-0"
                    }),
                    (0, vue_2.createElementVNode)("div", null, [
                        (0, vue_2.createElementVNode)("p", _hoisted_3, (0, vue_2.toDisplayString)(_ctx.$t("withdrawalPage.introText")), 1)
                    ])
                ]),
                (0, vue_2.createVNode)(_component_FormKit, {
                    type: "form",
                    "submit-label": _ctx.$t('withdrawalPage.submit'),
                    config: { validationVisibility: 'submit' },
                    errors: formErrors.value,
                    onSubmit: submit
                }, {
                    default: (0, vue_2.withCtx)(function () {
                        var _a;
                        return [
                            (0, vue_2.createElementVNode)("h3", _hoisted_4, (0, vue_2.toDisplayString)(_ctx.$t("withdrawalPage.sectionPersonalData")), 1),
                            (0, vue_2.createElementVNode)("p", _hoisted_5, (0, vue_2.toDisplayString)(_ctx.$t("withdrawalPage.requiredFieldHint")), 1),
                            (0, vue_2.createVNode)(_component_FormKit, {
                                modelValue: (0, vue_2.unref)(use_messageData_1.firstName),
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((0, vue_2.isRef)(use_messageData_1.firstName) ? (use_messageData_1.firstName).value = $event : null); }),
                                type: "ocmTextInput",
                                "input-type": "text",
                                label: "".concat(_ctx.$t('personalDataPage.firstName'), "*"),
                                name: _ctx.$t('personalDataPage.firstName'),
                                validation: "required",
                                plugins: [(0, vue_2.unref)(use_trackingErrors_1.useErrorTracking)().trackingPlugin]
                            }, null, 8, ["modelValue", "label", "name", "plugins"]),
                            (0, vue_2.createVNode)(_component_FormKit, {
                                modelValue: (0, vue_2.unref)(use_messageData_1.lastName),
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((0, vue_2.isRef)(use_messageData_1.lastName) ? (use_messageData_1.lastName).value = $event : null); }),
                                type: "ocmTextInput",
                                "input-type": "text",
                                label: "".concat(_ctx.$t('personalDataPage.lastName'), "*"),
                                name: _ctx.$t('personalDataPage.lastName'),
                                validation: "required",
                                plugins: [(0, vue_2.unref)(use_trackingErrors_1.useErrorTracking)().trackingPlugin]
                            }, null, 8, ["modelValue", "label", "name", "plugins"]),
                            (0, vue_2.createVNode)(_component_FormKit, {
                                modelValue: (0, vue_2.unref)(use_messageData_1.email),
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((0, vue_2.isRef)(use_messageData_1.email) ? (use_messageData_1.email).value = $event : null); }),
                                type: "ocmTextInput",
                                "input-type": "email",
                                label: "".concat(_ctx.$t('personalDataPage.email'), "*"),
                                name: _ctx.$t('personalDataPage.email'),
                                validation: "required|email",
                                plugins: [(0, vue_2.unref)(use_trackingErrors_1.useErrorTracking)().trackingPlugin],
                                disabled: (0, vue_2.unref)(use_messageData_1.emailDisabled)
                            }, null, 8, ["modelValue", "label", "name", "plugins", "disabled"]),
                            (0, vue_2.createElementVNode)("h3", _hoisted_6, (0, vue_2.toDisplayString)(_ctx.$t("withdrawalPage.sectionOrderData")), 1),
                            (0, vue_2.createVNode)(_component_FormKit, {
                                modelValue: (0, vue_2.unref)(use_messageData_1.orderNumber),
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return ((0, vue_2.isRef)(use_messageData_1.orderNumber) ? (use_messageData_1.orderNumber).value = $event : null); }),
                                type: "ocmTextInput",
                                "input-type": "text",
                                inputmode: "numeric",
                                maxlength: "8",
                                "outer-class": "$reset mb-2",
                                label: "".concat(_ctx.$t('withdrawalPage.orderNumber'), "*"),
                                name: _ctx.$t('withdrawalPage.orderNumber'),
                                validation: "required|matches:/^[0-9]{8}$/",
                                "validation-messages": {
                                    matches: _ctx.$t('orderPage.lengthErrorMessage'),
                                },
                                plugins: [(0, vue_2.unref)(use_trackingErrors_1.useErrorTracking)().trackingPlugin]
                            }, null, 8, ["modelValue", "label", "name", "validation-messages", "plugins"]),
                            (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                (0, vue_2.createVNode)(SvgIcon_vue_1.default, {
                                    "icon-name": "info",
                                    class: "h-5 w-5"
                                }),
                                (0, vue_2.createVNode)(InfoModal_vue_1.default, {
                                    headline: _ctx.$t('withdrawalPage.orderNumberHelp')
                                }, {
                                    trigger: (0, vue_2.withCtx)(function () { return [
                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(_ctx.$t("withdrawalPage.orderNumberHelp")), 1)
                                    ]; }),
                                    default: (0, vue_2.withCtx)(function () { return [
                                        (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(_ctx.$t("orderPage.helpText")), 1)
                                    ]; }),
                                    _: 1
                                }, 8, ["headline"])
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_8, [
                                (0, vue_2.createElementVNode)("label", _hoisted_9, (0, vue_2.toDisplayString)(_ctx.$t("withdrawalPage.articleNumbers")), 1),
                                (0, vue_2.createElementVNode)("span", _hoisted_10, (0, vue_2.toDisplayString)(articleNumbersCharacterCount.value) + "/" + (0, vue_2.toDisplayString)(articleNumbersMaxLength), 1)
                            ]),
                            (0, vue_2.createVNode)(_component_FormKit, {
                                id: "withdrawal-article-numbers",
                                modelValue: (0, vue_2.unref)(use_messageData_1.description),
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) { return ((0, vue_2.isRef)(use_messageData_1.description) ? (use_messageData_1.description).value = $event : null); }),
                                type: "textarea",
                                "outer-class": "$reset mb-2",
                                placeholder: _ctx.$t('withdrawalPage.articleNumbersPlaceholder'),
                                name: _ctx.$t('withdrawalPage.articleNumbers'),
                                maxlength: articleNumbersMaxLength,
                                plugins: [(0, vue_2.unref)(use_trackingErrors_1.useErrorTracking)().trackingPlugin]
                            }, null, 8, ["modelValue", "placeholder", "name", "plugins"]),
                            (0, vue_2.createElementVNode)("div", _hoisted_11, [
                                (0, vue_2.createVNode)(SvgIcon_vue_1.default, {
                                    "icon-name": "info",
                                    class: "text-primary-black mt-0.5 h-5 w-5 shrink-0"
                                }),
                                (0, vue_2.createElementVNode)("p", _hoisted_12, (0, vue_2.toDisplayString)(_ctx.$t("withdrawalPage.helperText")), 1)
                            ]),
                            ((_a = (0, vue_2.unref)(captcha_config_1.captchaData)) === null || _a === void 0 ? void 0 : _a.captchaActive)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                    key: 0,
                                    ref_key: "captchaElement",
                                    ref: captchaElement
                                }, null, 512))
                                : (0, vue_2.createCommentVNode)("", true),
                            (0, vue_2.createElementVNode)("p", _hoisted_13, (0, vue_2.toDisplayString)(_ctx.$t("withdrawalPage.legalText")), 1)
                        ];
                    }),
                    _: 1
                }, 8, ["submit-label", "errors"]),
                ((_a = (0, vue_2.unref)(captcha_config_1.captchaData)) === null || _a === void 0 ? void 0 : _a.captchaActive)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_14, (0, vue_2.toDisplayString)(_ctx.$t("personalDataPage.captchaText")), 1))
                    : (0, vue_2.createCommentVNode)("", true)
            ]));
        };
    }
});
